import http from '@/libs/http'


/**
 * 获取店铺技术支持二维码
 */
export const getTechSupportContact = ()=>{
    return http.request({
        url: '/u/techSupport/getQrCode',
        params: {

        },
        method: 'get'
    })
}

export const getRegisterChannel = ()=>{
    return http.request({
        url: '/u/techSupport/getRegisterChannel',
        params: {

        },
        method: 'get'
    })
}


/**
 * 获取扫码记录
 */
export const listTechSupportVisitor = (pageNo,pageSize)=>{
    return http.request({
        url: '/s/admin/techSupport/listVisitor',
        params: {
            pageNo,pageSize
        },
        method: 'get'
    })
}
